import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { TableCell, TableRow } from '@mui/material';
import { LabMaterial } from 'models/material';
import MaterialBatcherTooltip from '../shared/material-batcher-tooltip/material-batcher-tooltip.component';
import ActiveIndicator from 'components/users/shared/active-indicator/active-indicator.component';

type MaterialItemProps = {
    material: LabMaterial;
    onMaterialRowClick: (material: LabMaterial) => void;
    showInactiveDateCell: boolean;
};

const MaterialItem: FC<MaterialItemProps> = ({
    material,
    onMaterialRowClick,
    showInactiveDateCell,
}: MaterialItemProps) => {
    return (
        <TableRow hover sx={{ cursor: 'pointer' }} onClick={() => onMaterialRowClick(material)}>
            <TableCell sx={{ width: 10 }} align="center">
                <ActiveIndicator isActive={!material.inactive} />
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>{material.materialCode}</TableCell>
            <TableCell>{material.description}</TableCell>
            <TableCell align="center">
                <MaterialBatcherTooltip material={material} />
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {material.addedDate && formatDate(new Date(parseInt(material.addedDate)), 'date')}
            </TableCell>
            {showInactiveDateCell && (
                <TableCell>
                    {material.inactivatedDate && formatDate(new Date(parseInt(material.inactivatedDate)), 'date')}
                </TableCell>
            )}
        </TableRow>
    );
};

export default MaterialItem;
